import classNames from 'classnames'
import lodash from 'lodash'
import * as React from 'react'

import {getSizeClassName} from '@base-uikit/styles/grid'

import css from './GroupLayout.css'

export function forwardGroupLayoutProps(props) {
  return lodash.pick(props, ['siblings'])
}

export default function GroupLayout(props) {
  const {vertical, children, tabIndex, autoFocus, ...otherProps} = props
  let elements
  if (!children) {
    elements = []
  } else if (!Array.isArray(children)) {
    elements = [children]
  } else {
    elements = children.filter((x) => !!x)
  }

  return (
    <div
      {...otherProps}
      className={classNames([
        css.GroupLayout,
        vertical ? css.vertical : css.horizontal,
        props.className,
        getSizeClassName(props, css),
      ])}
    >
      {elements.map((el, index) => {
        let siblings = el.props.siblings
        if (elements.length > 1) {
          siblings = siblings ? siblings + ',' : ''
          if (index === 0) {
            siblings = vertical ? 'bottom' : 'right'
          } else if (index === elements.length - 1) {
            siblings = vertical ? 'topCollapse' : 'leftCollapse'
          } else {
            siblings = vertical ? 'bottom,topCollapse' : 'right,leftCollapse'
          }
        }
        return React.cloneElement(el, {
          key: index,
          siblings,
          // reuse original child tabIndex & autoFocus, otherwise use group's one
          tabIndex: tabIndex === undefined ? el.props.tabIndex : tabIndex,
          autoFocus: el.props.autoFocus || (autoFocus && index === 0),
        })
      })}
    </div>
  )
}

GroupLayout.displayName = 'GroupLayout'
